import { Col, Form, Row } from '@valid-eval/shared-react-components';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import Input from 'components/Form/Input';
import { Document } from 'data/features/documentsTypes';
import { Event } from 'data/features/eventsTypes';
import { useTranslation } from 'react-i18next';
import CheckboxList from 'components/Form/CheckboxList';
import FileInput from 'components/Form/FileInput';

export type DocumentFormValues = Document & {
  recipient_values?: (boolean | string)[];
  file_preview?: string;
  file_url?: string;
  file_name?: string;
};

type DocumentFormProps = {
  methods: UseFormReturn<DocumentFormValues>;
  event: Event;
  onSubmit: (data: DocumentFormValues) => void;
};

export const DocumentForm = ({ methods, event, onSubmit }: DocumentFormProps) => {
  const { t } = useTranslation();

  return (
    <FormProvider {...methods}>
      <Form onSubmit={methods.handleSubmit(onSubmit)}>
        <Row className="mb-2">
          <Col md={12}>
            <Input name="title" label={t('event.form.document_title')} required autoFocus />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md={12}>
            <CheckboxList
              id="document-recipient"
              name="recipient_values"
              label={t('event.form.document_recipient')}
              options={[
                { label: t('event.form.document_recipient_judges'), value: 'judges' },
                { label: t('event.form.document_recipient_teams'), value: 'teams' },
              ]}
              layout="row"
              required
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md={12}>
            <Input name="instructions" label={t('event.form.document_details')} as="textarea" />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md={12}>
            <FileInput
              label={t('event.form.document_file')}
              name="file_url"
              id="file_url"
              acceptedFileType="*"
              onFinishUpload={(_, url, file) => {
                methods.setValue('file_preview', URL.createObjectURL(file));
                methods.setValue('file_url', url);
                methods.setValue('file_name', file.name);
                methods.trigger();
              }}
              onNoSession={() => {}}
              signingUrl={`/api/v1/events/${event.id}/documents/upload_link`}
              value={
                methods.watch('file_url')
                  ? {
                      url: methods.watch('file_preview') ?? methods.watch('file_url'),
                      file_name: methods.watch('file_name'),
                    }
                  : undefined
              }
              hideDelete
              rules={{
                validate: {
                  required: () => (methods.getValues('file_url') ? true : false),
                },
              }}
            />
          </Col>
        </Row>
        <input type="submit" className="d-none" />
      </Form>
    </FormProvider>
  );
};

export default DocumentForm;
